module.exports = __webpack_public_path__ + "media/images/icon_article01_19-18-3cb56b72f30c51d7ccc78004aa85bcbf.png";